<template>
    <HeaderContent title="Driver & Guide"/>
    <ActionContent ctaText="Vehicle" @action="modal = !modal "/>
    <AdminStatistics title="Driver & Guide Statistics" :data="statistics" />
    <VehicleForm :modal="modal" @updateModal="modal = !modal"></VehicleForm>
    <AdminDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions">
    </AdminDataTable>
    
</template>

<script>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import VehicleForm from './VehicleForm.vue';
import AdminDataTable from '@/components/DataTable.vue';
import AdminStatistics from '@/components/StatisticData.vue';
import iconCar from '../../../public/icons/car.svg';
import iconBus from '../../../public/icons/bus-alt.svg';
import iconDamage from '../../../public/icons/damage.svg';
import iconOveral from '../../../public/icons/square-poll-vertical.svg';
import vehicleDummy from '@/dummy-data/vehicle'
import { ref,} from 'vue';
export default {
    name : 'VehicleIndex',
    components : {
        HeaderContent,
        ActionContent,
        VehicleForm,
        AdminDataTable,
        AdminStatistics,
    },
    setup(){
        const modal = ref(false)
        const statistics = ref([
            {
                label: 'Total',
                key: 'Car',
                value: 3,
                color: 'info',
                icon: iconCar,
            },
            {
                label: 'Total',
                key: 'Bus',
                value: 3,
                color: 'info',
                icon: iconBus,
            },
            {
                label: 'Total',
                key: 'Maintenance',
                value: 3,
                color: 'danger',
                icon: iconDamage,
            },
            {
                label: 'Total',
                key: 'Overall',
                value: 3,
                color: 'info',
                icon: iconOveral,
            },
        ])
        const headers = ref([
            {key : 'license_number',label: 'License Number',sortable: true,},
            {key : 'vehicle_name', label : 'Vehicle Name',sortable: true, },
            {key : 'type', label : 'Type',sortable: true, },
            {key : 'condition', label : 'Condition',sortable: true, },
            {key : 'year_bought', label : 'Year Bought',sortable: true,},
            {key : 'total_km', label : 'Total KM',sortable: true,},
            {key : 'last_maintenance', label : 'Last Maintenance',sortable: true,},
            {key: 'action', label: 'Actions',}
        ])
        const customActions = ref([
            
        
            {
                label: 'Edit',
                variant: 'success',
                icon: 'fas fa-edit',
                action: (item) => {
                console.log('Edit action clicked for:', item);
                // Implement your edit logic here
                }
            },
            {
                label: 'Delete',
                variant: 'danger',
                icon: 'fas fa-trash',
                action: (item) => {
                console.log('Delete action clicked for:', item);
                // Implement your delete logic here
                }
            },
            
        ]);
        const data = vehicleDummy
        
        return {
            modal, statistics, headers, customActions, data
        }
    }
}

</script>

